import { TFunction } from 'i18next';

export enum ReceptionCategory {
  helios = 0,
  customerContact = 1,
}

export enum ElevatorStatus {
  recoveryComplete = 1,
  suspended = 2,
  communicationInProgress = 3,
  noStatus = 4,
}

export const resolveElevatorTitle = (
  elevatorStatus: ElevatorStatus | undefined,
  t?: TFunction | undefined
): string => {
  if (elevatorStatus === undefined) {
    return '';
  }

  switch (elevatorStatus) {
    case ElevatorStatus.recoveryComplete:
      return t ? t('eris.supportStatusList.recoveryComplete') : 'Recovery complete';
    case ElevatorStatus.suspended:
      return t ? t('eris.supportStatusList.suspended') : 'Suspended';
    case ElevatorStatus.communicationInProgress:
      return t ? t('eris.supportStatusList.communicationInProgress') : 'Communication in Progress';
    case ElevatorStatus.noStatus:
      return t ? t('eris.supportStatusList.noStatus') : 'No status';
  }
};

export interface StatusModel {
  customerNumber: string;
  operationStatus: ElevatorStatus;
  unit: string;
  buildingName: string;
  address: string;
  helios: boolean;
  sensor: boolean;
  receptionIndicator: ReceptionCategory[];
  confinementStatus: number;
  supportStatus: string;
}
